import { createContext, useRef, useEffect } from 'react';
import { dBConn, setTimeFormat, API_ADRWS, AM_socketId } from './API_GET';

const InfoContext = createContext();

const InfoProvider = ({ initialData, children }) => {
    /*const [info, setInfo] = useState({
        'download': {status: 'none'},
        'upload': {status: 'none'},
        'scriptsubtitles': {
          status: 'none',
          address: ''
        },
    });*/

    const info = useRef({
        download: {status: 'none'},
        upload: {status: 'none'},
        scriptsubtitles: {
          status: 'none',
          address: ''
        },
    });

    const portalRef = useRef(null);
    const portalOpen = useRef(null);
    
    const userData = useRef(initialData);
    const compRefs = useRef({});
    
    const refreshComponents = (newUserData, taskId) => {
        const refreshRefs = new Set();
        
        Object.entries(newUserData).forEach(([k, v]) => {
            if(k === 'permissions') {
                if(JSON.stringify(v) !== JSON.stringify(userData.current.permissions)) {               
                    userData.current?.permissionsMap?.forEach(p => {
                        if(userData.current.permissions?.[p] !== v?.[p]) {
                            compRefs.current?.[p]?.forEach(r => refreshRefs.add(r));
                        }
                    })
                }
            } else {
                if(v !== userData.current[k]) compRefs.current?.[k]?.forEach(r => refreshRefs.add(r));
            }
        })
        
        userData.current = newUserData;
        setTimeFormat(newUserData.timeformat12 === 'true');
        refreshRefs.forEach(r => { r?.() })
    }
  
    const setInfoData = (data) => {
        info.current = data;
        window.dispatchEvent(new CustomEvent('infoDataChanged', { detail: data }));
    };

    const wsConnected = useRef(true);
    const webSocketFunctions = useRef({});    
    const openSubscriptions = useRef({});
    const socket = useRef(null);
    const intervalId = useRef(null);
    
    const reconnectToWs = useRef(null);
    
    const subscribeToWebSocket = (data, type, subscribe) => {
        if(!subscribe) {
            delete openSubscriptions.current?.[type];
        } else {
            openSubscriptions.current[type] = data;
        }
        if(socket.current?.readyState === WebSocket.OPEN) socket.current.send(JSON.stringify(data));
        if(!AM_socketId()) { reconnectToWs.current?.() }
    }
    
    useEffect(() => {
        
        wsConnected.current = false;
        
        const setClearInterval = (value) => {
            if(intervalId.current) {
                clearInterval(intervalId.current);
                intervalId.current = null;
            }
            if (!value) { return }
            intervalId.current = setInterval(() => {  
                if(wsConnected.current) return;
                const rootElement = document.getElementById('root');
                if (rootElement && rootElement.innerHTML.trim() === '') return;
                if(!AM_socketId()) { webSocketConnect() } 
                //update userData
                dBConn.get('refreshMenu=1').then((response) => refreshComponents(response));
                //update script
                webSocketFunctions.current?.script?.(null, true);
            }, 60000);
        };
        
        const webSocketConnect = () => {
            if(socket.current?.readyState === WebSocket.OPEN || window.location.hostname === "dev.kantanaudiomate.com") return
            if(!userData.current?.id) return;

            openSubscriptions.current['userData'] = {updateType: "userData", userId: userData.current.id};
        
            socket.current = new WebSocket(API_ADRWS('audiomate')); 
    
            socket.current.onopen = () => {
                wsConnected.current = true;
                setClearInterval(false);
                console.log('Connection established with WebSocket server');
                Object.values(openSubscriptions.current).forEach(s => socket.current.send(JSON.stringify(s)));
            };
            
            socket.current.onmessage = (event) => {
                let message = null;
                try { message = JSON.parse(event.data) } catch (error) { return }
                
                if(message.updateType === 'userConnected') { 
                    AM_socketId(true, message.userId);
                    return;
                };
                
                if(AM_socketId() === message.userId) { return } 
                
                if(message.sub === 'script') {
                    webSocketFunctions.current?.script?.(message);
                } else if(message.sub === 'scheduler') {
                    webSocketFunctions.current?.scheduler?.(message);
                } else if(message.sub === 'xloc') {
                    webSocketFunctions.current?.xloc?.(message);
                } else if(message.sub === 'userData') {
                    dBConn.get('refreshMenu=1').then((response) => refreshComponents(response));
                }                   
            }; 
            
            socket.current.onclose = () => {
                AM_socketId(true, null);
                wsConnected.current = false;
                setClearInterval(true);
                console.log('Connection closed with WebSocket server');
            };
            
        }
        
        reconnectToWs.current = webSocketConnect; 
        webSocketConnect();
        
        return () => {
            wsConnected.current = true;
            setClearInterval(false);
            if(socket.current?.readyState === WebSocket.OPEN) { socket.current?.close() }
        }
        
    }, []);  

    return (
        <InfoContext.Provider value={
            { 
                userData, 
                compRefs, 
                refreshComponents,
                info,
                setInfoData,
                portalRef,
                portalOpen,
                webSocketFunctions,
                subscribeToWebSocket, 
            }
        }>
            {children}
        </InfoContext.Provider>
    );
};

export { InfoContext, InfoProvider };

/* instruction to use context 


//////////////////// for download ///////////////////////////

//  1. import the script. Located in ...
//    import  {InfoContext}  from './AM_BackGroundOP';
//  2. import the context in the component 
//    const { info, setInfoData } = useContext(InfoContext);
//  3. key of array for download

    [
      {
          to: "12345.wav", from: "71/source/13384.wav"
      },
      {
          to: "12346.wav", from: "71/source/13388.wav"
      }
    ]


//  4. start the download

//  multiple file (send just one object in the array) 

    setInfoData(previous => ({
        ...previous,
        download: {
            status: 'request',
            outputFilename: 'zipname.zip', 
            fileList: arrayOfFiles
        }
    }))

//  single file 

    setInfoData(previous => ({
        ...previous,
        download: {
            status: 'request',
            outputFilename: 'audiofile.wav', // or nothing for tak the original name  
            fileList: arrayOfFiles // just one object in the array
        }
    }))


*/